import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react'

export function Field({
  label,
  children,
  hint,
}: {
  label: string
  children: ReactNode
  hint?: string
}) {
  return (
    <label className="flex flex-col gap-1.5 text-sm">
      <span className="kicker text-second-admin">{label}</span>
      {children}
      {hint ? <span className="text-xs text-second-admin">{hint}</span> : null}
    </label>
  )
}

const inputClass =
  'rounded-champ border border-bordure-admin bg-page px-3 py-2 text-encre-admin outline-none focus:border-encre-admin'

export function TextInput(props: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={`${inputClass} ${props.className ?? ''}`} />
}

export function TextArea(props: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea {...props} className={`${inputClass} min-h-24 ${props.className ?? ''}`} />
}

export function Select(props: SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} className={`${inputClass} ${props.className ?? ''}`} />
}

export function BtnPrimary({
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      {...props}
      className={`kicker rounded-pilule bg-encre-admin px-3.5 py-2 text-creme disabled:opacity-50 ${props.className ?? ''}`}
    >
      {children}
    </button>
  )
}

export function BtnGhost({
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      {...props}
      className={`kicker rounded-pilule border border-bordure-admin px-3.5 py-2 text-encre-admin disabled:opacity-50 ${props.className ?? ''}`}
    >
      {children}
    </button>
  )
}
